import React, { Fragment } from 'react'

import { ChevronIcon } from '@myxplor/icons'
import { Heading, Pill } from '@myxplor/ui'
import { Link, withRouter } from 'react-router-dom'

import WeekPicker from './week-picker'
import { currentWeek } from './helpers'
import { prevWeek, nextWeek, dayFormat, weekFormatted } from '../../../week'
import './nav.css'

const weekURL = (base_url, start_date) => `${base_url}/${dayFormat(start_date)}`

const supHeading = ({ view_type, start_date }) => (
  <Fragment>
    <span>{view_type} during</span>
    {currentWeek(start_date) && <Pill>This week</Pill>}
  </Fragment>
)

const NavigateByWeekView = ({ base_url, history, start_date, view_type }) => (
  <div className="navigateByWeek--wrapper">
    <nav>
      <li>
        <Link
          className="navigateByWeek--link"
          title={weekFormatted(prevWeek(start_date))}
          to={weekURL(base_url, prevWeek(start_date))}>
          <ChevronIcon dir="left" />
          <span className="navigateByWeek--text">Prev</span>
        </Link>
      </li>
      <li>
        <WeekPicker
          selectedWeekStartDate={date => history.push(weekURL(base_url, date))}
          renderTopContent={(showWeekPicker, state) => (
            <Fragment>
              <a
                href={''}
                onClick={e => {
                  e.preventDefault()
                  showWeekPicker(!state.show)
                }}>
                <Heading
                  sup={supHeading({ view_type, start_date })}
                  className="navigateByWeek--week">
                  {weekFormatted(start_date)}
                </Heading>
              </a>
              {!state.show && (
                <div style={{ textAlign: 'center' }}>
                  Click date above to reveal calendar selector
                </div>
              )}
            </Fragment>
          )}
          weekStartDate={start_date}
        />
      </li>
      <li>
        <Link
          className="navigateByWeek--link"
          title={weekFormatted(nextWeek(start_date))}
          to={weekURL(base_url, nextWeek(start_date))}>
          <span className="navigateByWeek--text">Next</span>
          <ChevronIcon dir="right" />
        </Link>
      </li>
    </nav>
  </div>
)

export default withRouter(NavigateByWeekView)



// WEBPACK FOOTER //
// ./src/ui/navigate-by-week/views/index.jsx